<kh-dialog-header mat-dialog-title>{{ title }} </kh-dialog-header>
<div
    mat-dialog-content
    class="body-medium"
>
    <p [innerHTML]="message"></p>
</div>
<div
    mat-dialog-actions
    class="khts-mat-dialog-actions"
    align="end"
>
    @if (showCancelButton) {
        <kh-app-text-button (clicked)="onCancelAction()">
            {{ hasDismissActionTitle }}
        </kh-app-text-button>
    }
    <kh-app-flat-button (clicked)="onConfirmAction()">{{ hasConfirmationActionTitle }} </kh-app-flat-button>
</div>
